<ws-select
	[disabled]="!initialized"
	[(result)]="activeTenant"
	[options]="tenants"
	[transformer]="tenantSelectorTransform"
	class="tenant-selector"
></ws-select>
